export const SECTION_KEYS = Object.freeze({
  ACCOUNT_INFO: 'accountInfo',
  BUSINESS_INFO: 'businessInfo',
  CONTACT_INFO: 'contactInfo',
  MAILING_ADDRESS: 'mailingAddress',
  PAYMENT_INFO: 'paymentInfo',
  PRINCIPAL_ADDRESS: 'principalAddress'
});

// prettier-ignore
export const SECTION_ORDER = Object.freeze([
  SECTION_KEYS.BUSINESS_INFO,
  SECTION_KEYS.PRINCIPAL_ADDRESS,
  SECTION_KEYS.MAILING_ADDRESS,
  SECTION_KEYS.CONTACT_INFO,
  SECTION_KEYS.ACCOUNT_INFO,
  SECTION_KEYS.PAYMENT_INFO
]);

// prettier-ignore
export const SECTION_ORDER_HAS_AUTH_ACCOUNT = Object.freeze([
  SECTION_KEYS.BUSINESS_INFO,
  SECTION_KEYS.PRINCIPAL_ADDRESS,
  SECTION_KEYS.MAILING_ADDRESS,
  SECTION_KEYS.CONTACT_INFO,
  SECTION_KEYS.PAYMENT_INFO
]);
